if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // ── Instant free gift (2026-08-28) ─────────────────────────────────
        // The free Period Underwear used to be added by a SECOND request, fired
        // from a cartUpdate subscriber ~300ms after this one resolved. The
        // drawer painted - and its Checkout button went live - before the gift
        // line existed, so a shopper who tapped Checkout straight away bought
        // without it. /cart/add.js takes an items array with a PER-ITEM
        // selling_plan, so the pouches and the $0 gift now go up in ONE request
        // and the gift is in the cart before the drawer can open.
        //
        // Each landing page's gift box registers the hook below; every other
        // product form on the store never sees one and keeps the FormData path
        // exactly as it is today.
        let giftItem = null;
        try {
          if (typeof window.chewyGiftLineForCurrentSelection === 'function') {
            giftItem = window.chewyGiftLineForCurrentSelection({
              variantId: formData.get('id'),
              quantity: parseInt(formData.get('quantity'), 10) || 1,
            });
          }
        } catch (e) {
          console.warn('Gift hook threw - falling back to the deferred gift add', e);
        }

        let addUrl = `${routes.cart_add_url}`;
        let giftConfig = null;
        if (giftItem) {
          const pouches = {
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity'), 10) || 1,
          };

          // Derive the plan the way subscription.js's interceptor does
          // (subscribe toggle + checked tier radio) rather than trusting the
          // form's hidden selling_plan field: on a fresh load that field still
          // holds the Liquid default while the checked radio is the real tier.
          let plan = formData.get('selling_plan') || '';
          const subToggle = document.querySelector('#subscribe-save');
          if (subToggle) {
            const tierRadio = document.querySelector('input[name="quantity_radio_group"]:checked');
            plan = subToggle.checked ? (tierRadio && tierRadio.getAttribute('data-selling-id')) || plan : '';
          }
          if (plan) pouches.selling_plan = parseInt(plan, 10);

          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (!match) return;
            pouches.properties = pouches.properties || {};
            pouches.properties[match[1]] = value;
          });

          // Appstle's widget patches fetch AND XHR and force-injects its own
          // checked selling_plan into every /cart/add body. The $0 gift variant
          // rejects a selling plan with 422 "Cannot apply selling plan to
          // variant" - and a multi-item add is atomic, so that 422 would take
          // the pouches down with it. Appstle skips any URL carrying the literal
          // '?appstle=true'. Only the gift path uses it; a plain add still goes
          // exactly where it goes today.
          addUrl = `${routes.cart_add_url}?appstle=true`;
          giftConfig = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              // The hook may hand back ONE line or an ARRAY: at the 6-pouch tier the
              // shopper picks a size for each free pair, and two different sizes are
              // two separate variants, so they cannot ride on one line.
              items: [pouches].concat(giftItem),
              sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id).join(',') : '',
              sections_url: window.location.pathname,
            }),
          };
        }

        // One-word record of which path this add took, so "the gift still lags"
        // can be answered without guessing: 'instant' = pouches and gift in one
        // request, 'deferred' = fell back and the gift trails. Read it in the
        // console as window.__chewyGiftPath.
        window.__chewyGiftPath = giftConfig ? 'instant' : 'deferred';

        fetch(addUrl, giftConfig || config)
          .then((response) => response.json())
          .then((response) => {
            // A multi-item add is all-or-nothing. If the gift variant is ever
            // unavailable - inventory tracking switched back on, product
            // archived - the pouches would fail with it and the shopper could
            // not buy at all. The gift must never block the sale: retry the
            // pouches alone and leave the gift to the deferred reconciler that
            // has always backed this up.
            if (giftConfig && response && response.status) {
              console.warn(
                'Gift add rejected (' + response.status + ') - retrying pouches only:',
                response.description
              );
              window.__chewyGiftPath = 'deferred (gift rejected)';
              return fetch(`${routes.cart_add_url}`, config).then((retry) => retry.json());
            }
            return response;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            // The add itself normally succeeded here - it is the drawer render
            // that failed. Showing the shopper nothing at all is what makes them
            // tap again and duplicate the line, so always surface the cart.
            if (this.cart && typeof this.cart.refreshAndOpen === 'function') {
              this.cart.refreshAndOpen();
            } else if (this.cart && typeof this.cart.open === 'function') {
              this.cart.open();
            }
          })
          .finally(() => {
            this.releaseSubmitButton();
          });
      }

      // Dawn released the button as soon as the fetch resolved, leaving a window
      // where it looked idle but the drawer had not painted yet. A tap in that
      // window fires a second /cart/add, so hold the disabled state until the
      // drawer is actually on screen (whenVisible has its own safety timeout).
      releaseSubmitButton() {
        const finish = () => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        };

        if (this.error || !this.cart || typeof this.cart.whenVisible !== 'function') {
          finish();
          return;
        }

        this.cart.whenVisible().then(finish);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
